import React, { Component } from 'react';
class News extends Component {
  constructor() {
    super();
    this.state = { 
    };
  } 

  componentDidMount() {
   
  }
    

  render() {
    return (
        <div className="container-xxl py-5 wow fadeInUp inner_con_grey" data-wow-delay="0.1s">
            <div className="container inner_con">
                <h1 className="text-center mb-5">News</h1>
                <div className="owl-carousel news-carousel">
                    <div className="news-item bg-light rounded p-4">
                        <a href="#"><b>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</b></a>
                        <p className="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                    </div>
                    <div className="news-item bg-light rounded p-4">
                        <a href="#"><b>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</b></a>
                        <p className="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                    </div>
                    <div className="news-item bg-light rounded p-4">
                        <a href="#"><b>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</b></a>
                        <p className="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                    </div>
                    <div className="news-item bg-light rounded p-4">
                        <a href="#"><b>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</b></a>
                        <p className="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default News;
